import { createFileRoute } from "@tanstack/react-router";
import RetailEcommerce from "@/pages/industries/RetailEcommerce";

export const Route = createFileRoute("/industries/retail-ecommerce")({ component: RetailEcommerce });